import CardGrey from "../../../common/CardGrey"
import DefaultUpdater from "../../../common/DefaultUpdater"

import classes from '../Shared/Item.module.css'

const MajorMedSidebar = ({data}) => {
    return <CardGrey minHeight={'100%'}>
        <div className={classes.container}>
            <div className={`${classes.sidebar_row} ${classes.sidebar_row_text_small}`}>
                <DefaultUpdater type={'checkbox'} value={data.no_coverage} name={'no_coverage'} label={'No Coverage'} identifier={{type: 'case_major_med', field: 'no_coverage', type_id: data.id, folder: 'major_meds'}} extraOptions={{direction: 'reverse'}}/>
            </div>
            <div className={`${classes.sidebar_row} ${classes.sidebar_row_text_small}`}>
                <DefaultUpdater type={'checkbox'} value={data.no_insurance} name={'no_insurance'} label={'No Insurance'} identifier={{type: 'case_major_med', field: 'no_insurance', type_id: data.id, folder: 'major_meds'}} extraOptions={{direction: 'reverse'}}/>
            </div>
            <div className={`${classes.sidebar_row} ${classes.sidebar_row_text_small}`}>
                <DefaultUpdater type={'checkbox'} value={data.self_funded_erisa} name={'self_funded_erisa'} label={'Self-funded ERISA'} identifier={{type: 'case_major_med', field: 'self_funded_erisa', type_id: data.id, folder: 'major_meds'}} extraOptions={{direction: 'reverse'}}/>
            </div>
            <div className={`${classes.sidebar_row} ${classes.sidebar_row_text_small}`}>
                <div>
                    <h3 className={classes.sidebar_title}>Referral</h3>
                    <div className={classes.sidebar_checkbox_group}>
                        <DefaultUpdater type={'checkbox'} value={data.referral_required} name={'referral_required'} label={'Required'} identifier={{type: 'case_major_med', field: 'referral_required', type_id: data.id, folder: 'major_meds'}} extraOptions={{direction: 'reverse'}}/>

                        <DefaultUpdater type={'checkbox'} value={data.referral_recieved} name={'referral_recieved'} label={'Recieved'} identifier={{type: 'case_major_med', field: 'referral_recieved', type_id: data.id, folder: 'major_meds'}} extraOptions={{direction: 'reverse'}}/>
                    </div>
                </div>
            </div>
        </div>
    </CardGrey>
}

export default MajorMedSidebar
